import { render } from "./TrainerPreview.vue?vue&type=template&id=662a9d56&scoped=true"
import script from "./TrainerPreview.vue?vue&type=script&lang=js"
export * from "./TrainerPreview.vue?vue&type=script&lang=js"

import "./TrainerPreview.vue?vue&type=style&index=0&id=662a9d56&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662a9d56"]])

export default __exports__